/**
 *
 *
 */

/* 배송상태 */
export const SETTLEMENT_STATUS = {
  WAIT: {
    value: 'WAIT',
    title: '대기',
    color: 'default',
  },
  DECIDED: {
    value: 'DECIDED',
    title: '확정',
    color: 'green',
  },
  UNDECIDED: {
    value: 'UNDECIDED',
    title: '미확정',
    color: 'purple',
  },
};
